import { useDndContext } from '@dnd-kit/core';
import { dragOverlay } from './atom.drag-overlay.style.js';
import { OnImageTile } from './atom.tile.js';
import { jsx } from 'react/jsx-runtime';

function DragOverlayContent(props) {
  const {
    over
  } = useDndContext();
  const overId = (() => {
    if (over?.id === "drawer") {
      return "drawer";
    }
    if (over?.data.current?.["tileWithinId"] === props.tile.id) {
      return "current-dropzone";
    }
    if (over) {
      return "new-dropzone";
    }
    return undefined;
  })();
  return /*#__PURE__*/jsx("div", {
    className: dragOverlay,
    "data-over": overId,
    children: /*#__PURE__*/jsx(OnImageTile, {
      ...props,
      context: "overlay"
    })
  });
}

export { DragOverlayContent };
//# sourceMappingURL=atom.drag-overlay.js.map
